var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{attrs:{"interval":5000,"arrow":"always"}},_vm._l((_vm.bannerList),function(item,index){return _c('el-carousel-item',{key:index},[_c('div',{staticClass:"ue-banner",style:('background-image:url('+item.coverPhoto.url+')'),on:{"click":function($event){return _vm.goPage(item.url)}}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }